import './Icon_Bookmarkhp.css';

function Icon_Bookmarkhp() {
  return (
    
      <div className='bookmarkhp-icon-container'>
          <svg viewBox="0 0 24 24" className="bookmarkhp-icon-svg">
              <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/>
          </svg>
      </div>
            
  );
}

export default Icon_Bookmarkhp;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bookmark-icon lucide-bookmark"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>